import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar.tsx";
// import RightSidebar from "./components/RightSidebar.tsx";
import { supabase } from "./SupabaseClient.tsx";

import ReceiptLibrary from "./pages/ReceiptLibrary.tsx";
import LandingPage from "./pages/LandingPage.tsx";
import Settings from "./pages/Settings.tsx";
import ReceiptDetail from "./pages/ReceiptDetail.tsx";
import ReceiptUpload from "./pages/ReceiptUpload.tsx";
import Loading from "./pages/Loading.tsx";
import Savings from "./pages/Savings.tsx";
import Reimburse from "./pages/Reimburse.tsx";
import TaxCenter from "./pages/TaxCenter.tsx";

function App() {
  const [, setIsNavbarCollapsed] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [hasActiveSubscription, setHasActiveSubscription] = useState(false);

  useEffect(() => {
    const checkSubscription = (session) => {
      if (!session) {
        supabase.auth.signOut();
        return Promise.resolve();
      }

      setLoading(true);
      return supabase.functions
        .invoke("check-subscription", {
          method: "GET",
        })
        .then((response) => {
          if (response) {
            const { hasActiveSubscription } = response.data;
            if (hasActiveSubscription) {
              setHasActiveSubscription(true);
              setIsAuthenticated(true);
            } else {
              supabase.auth.signOut().then(() => {
                const checkoutUrl = `https://buy.stripe.com/cN23el4XKdrD17G3cc?prefilled_email=${session.user.email}`;
                window.location.href = checkoutUrl;
              });
            }
          } else {
            console.error("Error checking subscription:", response);
          }
        })
        .catch((error) => {
          console.error("Error invoking function:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    };

    const { data: authListener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (session) {
          if (event === "INITIAL_SESSION") {
            checkSubscription(session);
          } else if (event === "SIGNED_IN") {
            checkSubscription(session);
          } else if (event === "TOKEN_REFRESHED") {
            setIsAuthenticated(true);
            setLoading(false);
          }
        } else {
          // User is signed out
          setIsAuthenticated(false);
          setHasActiveSubscription(false);
          setLoading(false);
        }
      }
    );

    // Cleanup subscription on unmount
    return () => {
      authListener?.subscription?.unsubscribe();
    };
  }, []);

  useEffect(() => {
    document.body.classList.add("right-sidebar-collapsed");
  }, []);

  // useEffect(() => {
  //   if (isNavbarCollapsed) {
  //     document.body.classList.add("navbar-collapsed");
  //   } else {
  //     document.body.classList.remove("navbar-collapsed");
  //   }
  // }, [isNavbarCollapsed]);

  if (loading) {
    return <Loading />;
  }

  return (
    <Router>
      <div className="App">
        {isAuthenticated && hasActiveSubscription ? (
          <>
            <Navbar onCollapse={setIsNavbarCollapsed} />
            <Routes>
              <Route path="/receipt-upload" element={<ReceiptUpload />} />
              <Route path="/receipt-library" element={<ReceiptLibrary />} />
              <Route path="/receipt-library/:id" element={<ReceiptDetail />} />
              <Route path="/reimburse" element={<Reimburse />} />
              <Route path="/savings" element={<Savings />} />
              <Route path="/tax-center" element={<TaxCenter />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="*" element={<Navigate to="/savings" />} />
            </Routes>
            {/* <RightSidebar isNavbarCollapsed={isNavbarCollapsed} /> */}
          </>
        ) : (
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;
